import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './executiveDashboardOverview.jade';

export class ExecutiveDashboardOverviewController {
  /* @ngInject */
  constructor(Resource, $filter, $timeout, currentUser, hideThatProduct) {
    this.translate = $filter('translate');
    this.ExecutiveAnalyticsOverviewResource = Resource('executive-analytics/overview-opt', {baseUrl: '/api/v2'});
    this.lastQuery = {};
    this.$timeout = $timeout;
    this.hideThatProduct = hideThatProduct;

    currentUser.subscribe((user) => {
      if(user) {
        this.hideAcquisitionProduct = this.hideThatProduct.hideAcquisitionProduct(user);
      }
    });

    this.query
      .distinctUntilChanged(JSON.stringify)
      .subscribe((query) => {
        this.getData(query);
      });

    this.currency = 'USD';

  }

  getData(query) {
    this.lastQuery = query;
    let params = _.merge({}, query, {top_n: 20});
    this.ExecutiveAnalyticsOverviewResource.one().get(params)
      .then((res) => this.overviewData = res.data)
  }

  refreshData() {
    this.getData(this.lastQuery);
  }
}

export function ExecutiveDashboardOverviewComponent() {
  return {
    template,
    controller: ExecutiveDashboardOverviewController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      query: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.games.executiveDashboardOverview', [
    ConfigsModule.name,
    ServicesModule.name,
    ResourcesModule.name
  ])
  .directive('executiveDashboardOverview', ExecutiveDashboardOverviewComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/executiveDashboardOverview.js
 **/